export const AFFILIATE_KEY = "aff_id"

// The query params the legacy helper reads (app/assets/javascripts/helpers.js
// `storeAffiliateCode`: `aff_id` first, then `aff`).
const PARAMS = ["aff_id", "aff"]
const DAYS_KEPT = 30

// Captures the affiliate attribution for the sign up page (P11-H3) exactly as
// the legacy helper does: a code in the URL is stored for 30 days under the
// same key and record shape ({ code, expiry }), a stored record past its
// expiry is dropped, and a bare code left by the oldest helper is re-stored
// with an expiry. A visit that starts on a legacy page and ends here (or the
// reverse) therefore reads one attribution. Returns the code to post, or null.
// `storage` may be null (the browser refused it): the URL code still posts.
export function captureAffiliate(search, storage, now = new Date()) {
  const params = new URLSearchParams(search)
  const fromUrl = PARAMS.map((key) => params.get(key)).find((value) => value) ?? null
  if (!storage) return fromUrl

  try {
    if (fromUrl) return store(storage, fromUrl, now)

    const raw = storage.getItem(AFFILIATE_KEY)
    if (!raw) return null
    if (!raw.includes("expiry")) return store(storage, raw, now)

    const record = JSON.parse(raw)
    if (new Date(record.expiry) < now) {
      storage.removeItem(AFFILIATE_KEY)
      return null
    }
    return record.code || null
  } catch {
    // Storage can be unavailable (private mode, blocked site data); the URL
    // code still posts for this visit.
    return fromUrl
  }
}

function store(storage, code, now) {
  const expiry = new Date(now)
  expiry.setDate(expiry.getDate() + DAYS_KEPT)
  storage.setItem(AFFILIATE_KEY, JSON.stringify({ code, expiry }))
  return code
}
